import React, { useContext } from 'react';

import Link from 'components/shared/link';
import MainContext from 'context/main';

const Banner = () => {
  const {
    sharedBlocks: {
      banner: {
        sharedBlockBanner: { label, title, buttonText, url, show },
      },
    },
  } = useContext(MainContext);

  return (
    show && (
      <div className="banner safe-paddings">
        <div className="relative z-50 flex items-center justify-center space-x-3.5 bg-[#F5F1FE] py-3 px-5 md:hidden md:px-4">
          {label && (
            <span className="whitespace-nowrap rounded bg-primary-1 py-1.5 px-2 text-xs font-medium uppercase leading-none">
              {label}
            </span>
          )}
          <p className="text-base leading-tight md:text-sm">{title}</p>
          <Link
            className="whitespace-nowrap text-[13px]"
            to={url}
            size="sm"
            theme="black-underline"
          >
            <span className="sr-only">Link to the ${title}</span>
            {buttonText}
          </Link>
        </div>

        <Link
          className="relative z-50 hidden items-center justify-center space-x-2 bg-[#F5F1FE] py-3 px-5 md:flex md:px-4"
          to={url}
        >
          {label && (
            <span className="whitespace-nowrap rounded bg-primary-1 py-1.5 px-2 text-xs font-medium uppercase leading-none">
              {label}
            </span>
          )}
          <p className="text-base leading-tight md:text-sm">{title}</p>
        </Link>
      </div>
    )
  );
};

export default Banner;
